import type { ClassStudent, StudentUser } from "@/types/canonical";

type StudentUserWithGroup = StudentUser & { group?: string | null };

type Participant = StudentUserWithGroup | ClassStudent;

export const getGroupInitials = (name?: string | null) => {
  if (!name) return "";
  return name
    .split(" ")
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    ?.toUpperCase();
};

export const getParticipantFullName = (student: Participant) => {
  const fullName = `${student.firstname ?? ""} ${student.lastname ?? ""}`.trim();
  return fullName || "";
};

export const getParticipantInitials = (student: Participant) => {
  const parts = [student.firstname, student.lastname].filter(
    (value): value is string => Boolean(value)
  );

  if (parts.length === 0) {
    return "??";
  }

  return parts
    .map((value) => value[0]?.toUpperCase())
    .slice(0, 2)
    .join("");
};

export const getParticipantAvatar = (student: Participant) => {
  return (
    (student as any)?.photo_thumb?.medium ||
    (student as any)?.photo ||
    ""
  );
};

/**
 * Returns the translation key for the participant's role.
 * Use with t() function to get the translated label.
 */
export const getParticipantRoleLabel = (student: Participant): string => {
  const group = (student as StudentUserWithGroup).group ?? "student";

  switch (group) {
    case "student":
      return "label-student";
    case "teacher":
      return "label-teacher";
    case "manager":
      return "label-manager-role";
    case "proctor":
      return "label-proctor-role";
    case "reviewer":
      return "label-reviewer";
    case "admin":
      return "label-manager-role";
    default:
      return group;
  }
};
